export default __webpack_public_path__ + "static/media/img-slider-banpu-4.bb663f39.png";